import React from "react";
import { Link } from "react-router-dom";
import "../../assets/styles/master_category_admin.scss";
import "../../assets/styles/super_admin.scss";

export default function SuperAdminUnauthorizedPage() {
  return (
    <div className="mca-page super-admin-page">
      <div className="mca-card" style={{ textAlign: "center" }}>
        <h1 className="mca-hero__title">Unauthorized</h1>
        <p className="mca-hero__subtitle">
          You need a valid Super Admin session to view this page.
        </p>
        <Link to="/super-admin/login" className="sa-back-link">
          Go to Super Admin login
        </Link>
      </div>
    </div>
  );
}
